// components/MailSms/components/SendTab/StudentSelection.js
import React from 'react';
import { FiSearch } from 'react-icons/fi';
import { FixedSizeList as List } from 'react-window';
import LoadingSpinner from '../LoadingSpinner';

const ROW_HEIGHT = 88;
const LIST_HEIGHT = 384;

const StudentRow = ({ index, style, data }) => {
  const { students, selectedStudents, setSelectedStudents } = data;
  const student = students[index];

  return (
    <div style={style}>
      <label className="flex items-center p-3 hover:bg-gray-50 cursor-pointer border-b">
        <input
          type="checkbox"
          checked={selectedStudents.includes(student.id)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedStudents([...selectedStudents, student.id]);
            } else {
              setSelectedStudents(selectedStudents.filter(id => id !== student.id));
            }
          }}
          className="mr-3 text-purple-600 focus:ring-purple-500"
        />
        <div className="flex-1 min-w-0">
          <p className="font-medium text-gray-800 truncate">{student.name}</p>
          <p className="text-sm text-gray-600 truncate">{student.email || 'Email yok'}</p>
          <p className="text-xs text-purple-600 font-medium truncate">Öğretmen: {student.ogretmenler}</p>
          <p className="text-xs text-gray-500 truncate">{student.parent_phone || 'Telefon yok'}</p>
        </div>
      </label>
    </div>
  );
};

const StudentSelection = ({
  students,
  selectedStudents,
  setSelectedStudents,
  searchTerm,
  setSearchTerm,
  dataLoading,
  pagination,
  onLoadMore
}) => {
  return (
    <>
      <h3 className="text-lg font-semibold mb-4">Öğrenci Seçimi</h3>

      {/* Search */}
      <div className="relative mb-4">
        <input
          type="text"
          placeholder="Öğrenci ara..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
        <FiSearch className="absolute left-3 top-3 text-gray-400" />
      </div>

      {/* List */}
      <div className="border rounded-lg bg-white overflow-hidden">
        {dataLoading.students ? (
          <LoadingSpinner />
        ) : students.length === 0 ? (
          <div className="p-6 text-center text-sm text-gray-500">
            Öğrenci bulunamadı.
          </div>
        ) : (
          <List
            height={LIST_HEIGHT}
            itemCount={students.length}
            itemData={{ students, selectedStudents, setSelectedStudents }}
            itemSize={ROW_HEIGHT}
            width="100%"
          >
            {StudentRow}
          </List>
        )}
      </div>

      <div className="mt-4 flex justify-between items-center">
        <p className="text-sm text-gray-600">
          {selectedStudents.length} öğrenci seçildi
        </p>
        {pagination?.hasNext && (
          <button
            onClick={onLoadMore}
            disabled={dataLoading.studentsMore}
            className="mr-3 text-sm text-gray-600 hover:text-gray-800 disabled:text-gray-400"
          >
            {dataLoading.studentsMore ? 'Yukleniyor...' : 'Daha Fazla'}
          </button>
        )}
        <button
          onClick={() => setSelectedStudents(students.map(s => s.id))}
          className="text-sm text-purple-600 hover:text-purple-700"
        >
          Tümünü Seç
        </button>
      </div>
    </>
  );
};

export default StudentSelection;
